import React from 'react';
import { CtaFull } from './CtaFull';
import { CtaHalf } from './CtaHalf';

const CtaSelector = ({ sanity, page, section }) => {
  switch (section?.template) {
    case 'half':
      return <CtaHalf sanity={sanity} page={page} section={section} />;
    case 'full':
      return <CtaFull sanity={sanity} page={page} section={section} />;
    default:
      return null;
  }
};

CtaSelector.displayName = 'CtaSelector';

export { CtaSelector };
